import { render, staticRenderFns } from "./ManageInfoComponents.vue?vue&type=template&id=96901dfc"
import script from "./ManageInfoComponents.vue?vue&type=script&lang=js"
export * from "./ManageInfoComponents.vue?vue&type=script&lang=js"
import style0 from "./ManageInfoComponents.vue?vue&type=style&index=0&id=96901dfc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports